<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps({
  params: {
    type: Object,
    default: () => ({}),
  },
})

const companyName = computed(() => props.params?.data?.companyName)
const companySiret = computed(() => props.params?.data?.companySiret)
</script>

<template>
  <div class="flex flex-col items-start leading-tight py-0.5">
    <span class="block text-sm">{{ companyName || '-' }}</span>
    <span v-if="companySiret" class="block text-[11px] text-base-content/80 mt-0.5">{{ companySiret }}</span>
  </div>
</template>
